import $ from 'jquery';
import registerJQueryPlugin from 'styleguide/lib/register-jquery-plugin';
import { addToBagWithData } from 'modules/add-to-bag';

export const PLUGIN_NAME = 'addToBag';

const mergeOptions = ($el, options = {}) => {
    const opts = Object.assign({}, $el.data(), options);
    return opts;
};

const showSizeError = () => {
    $('#sizeError').fadeIn();
    $('#sizeErrorText').attr("role", "alert");
}

const getFitItemSizes = () => {
    return $('input[name=tryon-size-options]:checked').val();
}

const hideFittingRoom = () => {
    $('input[name=tryon-size-options]').prop('checked', false);
    $("#accordionTryOnItem").hide();
}

const setEventListeners = ($el, opts) => {
    $el.on('click', function() {
        const el = $(this);
        const code = $('#code').val();
        const size = $('#sizeValue').val();
        const isOOSSize = $('#sizeValue').data('oosSize');
        const assignedSellableDefectItemSerialNumber = $('#assignedSellableDefectItemSerialNumber').val();
        const isMens = $('#header-jsp').data('department') === 'Mens';

        if (size === null || size === '') {
            showSizeError();
            $('.size-options').focus();
        } else if(!isOOSSize) {
            el.prop('disabled', true);
            $(document).trigger('productAddedToBag');
            const fitItemsSelected = getFitItemSizes();
            if (fitItemsSelected && fitItemsSelected.trim().length) {
                hideFittingRoom();
            }
            let data = {
                productCode: code,
                size: size,
                sectionURL: window.rcProps.sectionUrl,
                sessionID: window.rcProps.sessionId,
                isMens: isMens,
                src: 'addtobag',
                csrfHash: window.rcProps.csrfHash,
                useReferrer: true,
                isPopup: false,
                qvclick: window.rcProps.qvClick,
                hotlistQuickView: false,
                focusID: el.attr('id'),
                fitItemSizes: fitItemsSelected,
                serial: assignedSellableDefectItemSerialNumber
            };
            if ($(".js-counter-value").length) {
                data.count = $(".js-counter-value").text();
            }
            if ($('#replenish-save').is(':checked')){
                data.subscriptionInterval = $('#subscription-interval option:selected').val();
            }

            addToBagWithData(data);
        } else {
            $('#sizeError').html(opts.oosText);
            $('#sizeError').css('display', 'block')
            $('#sizeError').delay(2000).fadeOut();
        }
    });
}

export default function addToBag(el, options) {
    const $el = $(el);
    const opts = mergeOptions($el, options);
    setEventListeners($el, opts);
}

registerJQueryPlugin(PLUGIN_NAME, addToBag);


// WEBPACK FOOTER //
// ./src/scripts/entry-points/pdp/add-to-bag.js